import React, { useState } from "react";
import { Loader2 } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Visualiseur 3D interactif (.glb / .gltf) via Google model-viewer.
 *  - chargement progressif
 *  - rotation/zoom souris + touch
 *  - bouton AR (mobile)
 *  - poster (image avant chargement)
 *
 * Props :
 *  - src       : URL relative ou absolue (ex: "/api/public/media/abc")
 *  - poster    : URL image fallback affichée pendant le chargement
 *  - caption   : légende affichée sous le viewer
 *  - height    : hauteur CSS (défaut 480px)
 */
export default function Model3DViewer({ src, poster, caption = "", height = "480px" }) {
  const [loaded, setLoaded] = useState(false);
  const full = src?.startsWith("http") ? src : `${BACKEND}${src}`;
  const posterFull = poster?.startsWith("http") ? poster : poster ? `${BACKEND}${poster}` : undefined;

  return (
    <div className="relative rounded-2xl overflow-hidden border border-[#E2E5F1] bg-gradient-to-br from-[#F8FAFC] to-[#E8EBFA]" data-testid="model3d-viewer">
      {!loaded && (
        <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-[#F8FAFC]/80 backdrop-blur-sm">
          <Loader2 className="w-7 h-7 text-[#1E3A8A] animate-spin mb-2" />
          <div className="text-xs text-[#4B5775] font-bold uppercase tracking-wider">Chargement de la maquette 3D…</div>
        </div>
      )}
      {/* model-viewer is a web component (custom element). React passes props as attributes. */}
      <model-viewer
        src={full}
        poster={posterFull}
        alt={caption || "Modèle 3D du bien"}
        camera-controls=""
        auto-rotate=""
        ar=""
        ar-modes="webxr scene-viewer quick-look"
        shadow-intensity="1"
        exposure="1"
        environment-image="neutral"
        style={{ width: "100%", height, background: "transparent" }}
        onLoad={() => setLoaded(true)}
      />
      {caption && (
        <div className="absolute bottom-3 left-3 right-3 bg-[#0F1A3D]/80 backdrop-blur text-white text-xs px-3 py-2 rounded-md font-medium">
          {caption}
        </div>
      )}
      <div className="absolute top-3 right-3 bg-white/95 text-[10px] uppercase tracking-wider font-bold text-[#1E3A8A] px-2.5 py-1 rounded">
        Maquette 3D
      </div>
    </div>
  );
}
